let IconButton = require("./IconButton");
let Format = require("../lib/Format.js");

let windowDragOver = function (evt) {
  evt.preventDefault();
};

let windowDrop = function (evt) {
  evt.preventDefault();
};

class FormFiles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dragging: false
    };
  }

  componentDidMount() {
    window.addEventListener("dragover", windowDragOver);
    window.addEventListener("drop", windowDrop);
  }

  componentWillUnmount() {
    window.removeEventListener("dragover", windowDragOver);
    window.removeEventListener("drop", windowDrop);
  }

  shouldComponentUpdate(nextProps, nextState) {
    let { files } = this.props;
    let { dragging } = this.state;

    return (dragging !== nextState.dragging) || (files.length !== nextProps.files.length);
  }

  onDragEnterFile(evt) {
    evt.preventDefault();

    this.setState({ dragging: true });
  }

  onDragExitFile(evt) {
    evt.preventDefault();

    this.setState({ dragging: false });
  }

  onDropFiles(evt) {
    evt.preventDefault();

    this.setState({ dragging: false });

    let { onUpdate } = this.props;

    let items = Array.from(evt.dataTransfer.items);

    let files = this.mergeFiles(items.map((item) => item.getAsFile()));

    onUpdate(files);
  }

  equalsFile(file1, file2) {
    return file1.name === file2.name && file1.lastModified === file2.lastModified;
  }

  mergeFiles(files) {
    let { allowTypes = [] } = this.props;

    let _files = Array.from(this.props.files);

    files.forEach((file2) => {
      let isNewFile = !_files.find((file1) => {
        return this.equalsFile(file1, file2);
      });

      let isAllowedFileType = !allowTypes.length || allowTypes.includes(file2.type);

      if (isNewFile && isAllowedFileType) {
        _files.push(file2);
      }
    });

    return _files;
  }

  triggerInput() {
    this.refs.file.click();
  }

  selectFiles(evt) {
    let { onUpdate } = this.props;

    let files = this.mergeFiles(Array.from(evt.target.files));

    onUpdate(files);
  }

  deleteFile(file2) {
    let { onUpdate } = this.props;

    let files = Array.from(this.props.files).filter((file1) => {
      return !this.equalsFile(file1, file2);
    });

    onUpdate(files);
  }

  render () {
    let { files, note } = this.props;
    let { dragging } = this.state;

    return (
      <div className="mc-form-files">
        <div
          data-dragging={dragging}
          onDrop={this.onDropFiles.bind(this)}
          onDragOver={this.onDragEnterFile.bind(this)}
          onDragLeave={this.onDragExitFile.bind(this)}>
          <div className="mc-form-files-target">
            <small>{note || tx("drag_files_here")}</small>
            <ul>
              {files.map((file, i) => {
                return (
                  <li key={i}>
                    <span>
                      <span>{`${file.name} (${Format.filesize(file.size)})`}</span>
                      <IconButton
                        icon="delete"
                        scale={0.7}
                        onPress={this.deleteFile.bind(this, file)}/>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
          <input
            ref="file"
            type="file"
            multiple={true}
            onChange={this.selectFiles.bind(this)}/>
        </div>
        <button className="mc-form-files-add" onClick={this.triggerInput.bind(this)}>
          {tx("add_files")}
        </button>
      </div>
    );
  }
}

module.exports = FormFiles;
